import Vue from "vue";
import VueRouter from "vue-router";

import WebView from "./modules/WebView";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

const routes = [
    {
        path: "/",
        redirect: { name: "WEB" },
        component: () => import("@/view/Index"),
        children: [
            {
                name: "WEB",
                path: "WEB",
                component: () => import("@/view/WebViews"),
                redirect: { name: "Home" },
                children: [...WebView]
            },
        ]
    },
]

Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    routes,
});

// 全局前置守卫：初始化时执行、每次路由切换时执行
router.beforeEach((to, from, next) => {
  // 让页面回到顶部
  document.documentElement.scrollTop = 0;
  next();
});

//全局后置守卫：初始化时执行、每次路由切换后执行
router.afterEach((to, from) => {
    if (to.meta.title) {
        document.title = to.meta.title //修改网页的title
    } else {
        document.title = '胜博知识产权'
    }
});

export default router;